import React from 'react';
import Container from 'container';
import s from './bg_image_text.module.scss';

export default function AdA({ background_image, text_1, text_2, ...props }) {
  return (
    <Container className={s.root} image={background_image}>
      <div className={s.wrapper}>
        <div className={s.column1}>
          <div
            className={s.text1}
            dangerouslySetInnerHTML={{ __html: text_1 }}
          />
        </div>
        <div className={s.column2}>
          <div
            className={s.text2}
            dangerouslySetInnerHTML={{ __html: text_2 }}
          />
        </div>
      </div>
    </Container>
  );
}
